module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container"
  }, [_c('div', {
    staticClass: "d-guides"
  }, [_c('StilGuides', {
    attrs: {
      "video-id": 'etaeiteazYM?start=112',
      "textForLink": "Guide: Se videoguide for ressourceforbrug"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "text-link",
    attrs: {
      "target": "_blank",
      "href": "https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2022/1012/Praktisk%20vejledning_Ressourceforbrug_2022.pdf"
    }
  }, [_vm._v("Læs\n      officiel vejledning fra STIL")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_c('thead', {
    staticClass: "center"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "225px"
    }
  }, [_c('div', {
    staticClass: "filter-and-select"
  }, [_c('span', {
    staticClass: "icon-filter"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeUserFilter),
      expression: "activeUserFilter"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeUserFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.stilStillingerWithCount), function(stilStilling) {
    return _c('option', {
      domProps: {
        "value": stilStilling.value
      }
    }, [_vm._v("\n              " + _vm._s(stilStilling.title) + " (" + _vm._s(stilStilling.count) + ")\n            ")])
  }), 0)])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Arbejdstimer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Fagopdelt undervisning")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Understøttende undervisning")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', {
    staticClass: "thead-second-row"
  }, [_c('th', [_c('div', {
    staticClass: "select-all-and-button"
  }, [_c('p', {
    staticClass: "select-all",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("Vælg alle")]) : _c('span', [_vm._v("Fravælg alle")])]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('div', {
    staticClass: "hint--bottom-left",
    attrs: {
      "aria-label": "Vælg brugere først"
    }
  }, [_c('button', {
    staticClass: "no-print bttn bttn--disabled"
  }, [_vm._v("\n              Indsæt på valgte\n            ")])]) : _c('button', {
    staticClass: "up__button",
    on: {
      "click": function($event) {
        _vm.isInsertOnMore = true
      }
    }
  }, [_vm._v("Indsæt på valgte")])])]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsersWithVProps), function(user, userIdx) {
    return _c('tr', {
      key: user.id
    }, [_c('td', {
      staticClass: "td__select-user",
      class: {
        'td__select-user--selected': _vm.theActiveUserId === user.id
      },
      on: {
        "click": function($event) {
          return _vm.selectUser(user.id)
        }
      }
    }, [_c('div', {
      staticClass: "name-and-title"
    }, [_c('div', {
      staticClass: "name-and-title__checkbox"
    }, [_c('div', {
      staticClass: "d-checkbox",
      class: {
        'd-checkbox--active': _vm.getIsUserSelected(user.id)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', [(user.v_stil_stilling_title) ? _c('p', {
      staticClass: "d-pill"
    }, [_vm._v("\n              " + _vm._s(user.v_stil_stilling_title) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": _vm.theActiveUserId !== user.id ? 'Se opgaveoversigt' : 'Luk opgaveoversigt'
      }
    }, [_c('div', {
      staticClass: "icon__bg-circle",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheActiveUserId(user.id)
        }
      }
    }, [(_vm.theActiveUserId !== user.id) ? _c('span', {
      staticClass: "icon-clipboard2"
    }) : _c('span', {
      staticClass: "icon-cross2"
    })])])])]), _vm._v(" "), (_vm.theActiveUserId === user.id) ? _c('StilRessourceTasks', {
      attrs: {
        "userId": user.id,
        "schoolYear": _vm.activeSchoolYear,
        "startDate": _vm.activeSchoolYear.employee_time_start,
        "endDate": _vm.activeSchoolYear.employee_time_end
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_total_normal),
        expression: "user.v_stil_hours_total_normal"
      }],
      class: {
        'number--empty': !user.v_stil_hours_total_normal
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_total_normal)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_40_B', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_total_normal", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_total_special),
        expression: "user.v_stil_hours_total_special"
      }],
      class: {
        'number--empty': !user.v_stil_hours_total_special
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_total_special)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_50_B', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_total_special", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_fag_normal),
        expression: "user.v_stil_hours_fag_normal"
      }],
      class: {
        'number--empty': !user.v_stil_hours_fag_normal
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_fag_normal)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_40_A1', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_fag_normal", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_fag_special),
        expression: "user.v_stil_hours_fag_special"
      }],
      class: {
        'number--empty': !user.v_stil_hours_fag_special
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_fag_special)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_50_A1', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_fag_special", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_uuv_normal),
        expression: "user.v_stil_hours_uuv_normal"
      }],
      class: {
        'number--empty': !user.v_stil_hours_uuv_normal
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_uuv_normal)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_40_A22', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_uuv_normal", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_uuv_special),
        expression: "user.v_stil_hours_uuv_special"
      }],
      class: {
        'number--empty': !user.v_stil_hours_uuv_special
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_uuv_special)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_50_A22', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_uuv_special", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_other_normal),
        expression: "user.v_stil_hours_other_normal"
      }],
      class: {
        'number--empty': !user.v_stil_hours_other_normal
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_other_normal)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_40_A33', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_other_normal", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_hours_other_special),
        expression: "user.v_stil_hours_other_special"
      }],
      class: {
        'number--empty': !user.v_stil_hours_other_special
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.v_stil_hours_other_special)
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'stil_hours_50_A33', $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "v_stil_hours_other_special", $event.target.value)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), (_vm.isInsertOnMore) ? _c('GrundskoleIndberetningRessourceInsertModal', {
    attrs: {
      "selectedUsers": _vm.selectedUserObjects,
      "schoolId": _vm.schoolId
    },
    on: {
      "updateRessource": _vm.updateRessourceFromModal,
      "close": _vm.closeInsertOnMore
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "italic"
  }, [_vm._v("Bemærk: I skal indberette, hvor mange undervisningsressourcer (målt i arbejdstimer), som skolen\n      råder over, og hvordan skolen planlægger at bruge de undervisningsressourcer"), _c('br'), _vm._v("\n      Arbejdstiden for en fuldstidslærer er 1924 timer. Ud af dette findes et skøn for tid brugt på: Undervisning, UUV\n      og Øvrig tid med eleverne (f.eks. elevsamtaler, gårdvagt og pause med eleverne)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Øvrig tid med eleverne"), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("(f.eks. elevsamtaler,\n        gårdvagt og pauser med eleverne)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03679bb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetningRessource.vue
// module id = 1733
// module chunks = 1